import gql from 'graphql-tag';

export const UPDATE_IMAGE_MODERATION_SERVER_MODELS = gql`
  mutation UpdateImageModerationServerModels($serverId: ID!, $modelIds: [ID!]!) {
    operationResult: updateImageModerationServerModels(serverId: $serverId, modelIds: $modelIds)
  }
`;
